import { Subject } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap';
import { RequestStatusEnum } from '../../shared/services/request-status.service';
import { FormBuilder } from '@angular/forms';
import { Sources } from '../../shared/services/request-comments.service';
var RequestRejectionModalComponent = /** @class */ (function () {
    function RequestRejectionModalComponent(modalRef, formBuilder) {
        this.modalRef = modalRef;
        this.onClose = new Subject();
        this.onRejected = new Subject();
        this.onBackToPlanning = new Subject();
        this.submittedOrAssigned = false;
        this.readyForReview = false;
        this.rejectionForm = formBuilder.group({
            comment: formBuilder.control(null)
        });
    }
    Object.defineProperty(RequestRejectionModalComponent.prototype, "comment", {
        get: function () { return this.rejectionForm.get("comment"); },
        enumerable: true,
        configurable: true
    });
    ;
    RequestRejectionModalComponent.prototype.ngOnInit = function () {
        this.submittedOrAssigned = this.request.statusId === RequestStatusEnum.Submitted || this.request.statusId === RequestStatusEnum.Assigned;
        this.readyForReview = this.request.statusId === RequestStatusEnum.ReadyForReview ? true : false;
    };
    RequestRejectionModalComponent.prototype.backToDraft = function () {
        this.onRejected.next({
            requestId: this.request.id,
            comment: this.comment.value,
            source: this.rejectionSource()
        });
    };
    RequestRejectionModalComponent.prototype.backToPlanning = function () {
        this.onBackToPlanning.next({
            requestId: this.request.id,
            comment: this.comment.value,
            source: Sources.rejectionFromPlannedToPlanning
        });
    };
    RequestRejectionModalComponent.prototype.closeModal = function () {
        this.modalRef.hide();
    };
    RequestRejectionModalComponent.prototype.rejectionSource = function () {
        switch (this.request.statusId) {
            case RequestStatusEnum.Submitted: return Sources.rejectionFromSubmitted;
            case RequestStatusEnum.Assigned: return Sources.rejectionFromAssigned;
            case RequestStatusEnum.ReadyForReview: return Sources.rejectionFromPlannedToDraft;
            default: return "ERROR: Status not found";
        }
    };
    return RequestRejectionModalComponent;
}());
export { RequestRejectionModalComponent };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/view-request/request-rejection-modal/request-rejection-modal.component.ts.pre-build-optimizer.js